import { sizer } from "layout/styles/styled/sizer";
import { Label } from "layout/typography/Label";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
import styled from "styled-components";
import { IOrder } from "types/Order/Order";

const StyledCard = styled(Card)`
  margin-bottom: ${sizer(2)};
  border: 1px solid var(--gray-new-200) !important;
`;

interface IPayerDetails {
  payerName: string;
  payerName2: string;
  placeOfService: string;
  locality: string;
}

function PayerDetails({ order }: { order: IOrder }) {
  const { control, setValue } = useFormContext<IPayerDetails>();
  const payerName2Field = (order.serviceDetails as any)?.secondaryPayerName;

  useEffect(() => {
    setValue("payerName", (order.serviceDetails as any)?.payerName || "Any");
    setValue(
      "payerName2",
      (order.serviceDetails as any)?.secondaryPayerName || "Any"
    );
  }, [order, setValue]);

  return (
    <StyledCard title="Patient Benefits">
      <div className="formgrid grid w-100">
        <div className="field flex flex-column col-12 md:col-4">
          <Label htmlFor="payerName">Payer Name</Label>

          <Controller
            name="payerName"
            control={control}
            render={({ field: { value } }) => (
              <InputText
                disabled
                data-testid="payerName"
                id="payerName"
                placeholder="Payer Name"
                value={value}
              />
            )}
          />
        </div>
        {payerName2Field && (
          <div className="field flex flex-column col-12 md:col-4">
            <Label htmlFor="payerName2">Secondary Payer</Label>

            <Controller
              name="payerName2"
              control={control}
              render={({ field: { value } }) => (
                <InputText
                  disabled
                  data-testid="payerName2"
                  id="payerName2"
                  placeholder="Secondary Payer"
                  value={value}
                />
              )}
            />
          </div>
        )}
      </div>
    </StyledCard>
  );
}

export default PayerDetails;
